module.exports = __webpack_public_path__ + "static/evolet-ae910f99af8c0e82bbeb5e807e4ce8c9.png";